import React, { useEffect, useState } from "react";
import SearchFilter from "../../../components/search-filter";
import { isAuthenticated } from "../../../auth";
import { startLoader, stopLoader } from "../../../lib/utils";
import Toast from "../../../lib/toast";
import { getAllContents, getContentsCount } from "../../content/helper/api";
import { throttle } from "lodash";

const ContentList = (props) => {

  const {user, token} = isAuthenticated();
  const [contents, setContents] = useState([]);
  const [nutritionContents, setNutritionContents] = useState([]);
  const [sortExerciseTypeIDs, setSortExerciseTypeIDs] = useState([]);
  const [sortExerciseLevelIDs, setSortExerciseLevelIDs] = useState([]);
  const [sortTargetMuscleIDs, setTargetMuscleIDs] = useState([]);
  const [ContentRole, setContentRole] = useState('All');
  const [ContentType, setContentType] = useState('');
  const [sortByAccessRight,setSortByAccessRight]=useState('');
  const [selectedGym, setSelectedGym] = useState('');
  const [branchIDs, setBranchIDs] = useState([]);
  const [contentVariation, setContentVariation]=useState("Workout");

  const [selectedWarmUpContent, setSelectedWarmUpContent] = useState([]);
  const [selectedCoolDownContent, setSelectedCoolDownContent] = useState([]);
  const [selectedDayContents, setSelectedDayContents] = useState([]);
  const [dayIndex, setDayIndex] = useState(-1);
  const [isMemberSpinnerLoader, setMemberSpinnerLoader] = useState(false);
  const [existingContents, setExistingContents] = useState([]);
  const [isContentPreviewOpen, setContentPreviewOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");


  const [pageSize, setPageSize] = useState({
    branch: 20,
    gym: 20,
    content: 20
  });
  const [pageCount, setPageCount] = useState({
    branch: 0,
    gym: 0,
    content: 0
  });
  const [total, setTotal] = useState({
    branch: 0,
    gym: 0,
    content: 0
  });
  var [pageNo, setPageNo] = useState({
    branch: 1,
    gym: 1,
    content: 1
  });

  const [searchKey, setSearchKey] = useState("");

  const GetParams = () => {
    let params = {
      pageNo: pageNo.content,
      pageSize: pageSize.content
    };
    params.activationStatus = "activate";
    if (searchKey) params.q = searchKey;
    if (sortExerciseLevelIDs.length) params.exerciseLevelIDs = sortExerciseLevelIDs;
    if (sortExerciseTypeIDs.length) params.exerciseTypeIDs = sortExerciseTypeIDs;
    if (sortTargetMuscleIDs.length) params.targetMuscleIDs = sortTargetMuscleIDs;
    if (ContentRole) params.contentRole = ContentRole;
    if (props.contentType) params.contentType = props.contentType == "warm-up" ? "warmup" : props.contentType == "day-workout" ? "mainexercise" : props.contentType == "cool-down" ? "cooldown" : "";
    if (ContentRole == 'branch' && props.selectedGym) params.branchIDs= [props.selectedGym._id];
    if (sortByAccessRight) params.accessRight=sortByAccessRight;

    return params;
  }

  const GetAllContents = async (isReload) => {
    try {
      let params = GetParams();

      console.log(params);

      let response = await getAllContents(user._id, token, params);
      if(response.error) {
        new Toast({
          message:response.error,
          duration:3000,
          type:'error'
        })
      }
      else{
        setContents(isReload?response:[...contents,...response]);
      }
    } catch (error) {
      
    }
  }

  const GetContentCount = async () => {
    try {
      let params = GetParams()
      let response = await getContentsCount(user._id, token, params);
      if(response.error){
        new Toast({
          message:response.error,
          duration:3000,
          type:'error'
        })
      }else{
        pageNo.content = 1;
        setPageNo(pageNo)
        setPageCount({
          ...pageCount,
          content: Math.ceil(response.COUNT / pageSize.content)
        })
        setTotal({
          ...total,
          content: response.COUNT
        })
      }
    } catch (error) {
      // do something
    }
  }

  const contentPrivacy = (value) => {
    setSortByAccessRight(value)
  }

  const contentRole = (value) => {
    if(value != ContentRole){
      setContentRole(value)
    }
  }

  const setParameterFilter = (data) => {
    setSortExerciseLevelIDs(data.exerciseLevel);
    setSortExerciseTypeIDs(data.exerciseType);
    setTargetMuscleIDs(data.targetMuscle);
  }

  const addContent = (content) => {
    if(ContentType == "warm-up" && !props.parentContentId){
      // setSelectedWarmUpContent({...selectedWarmUpContent, content})
      props.handleWarmUpContent(content);
    }

    if(ContentType == "warm-up" && props.parentContentId){
      // setSelectedWarmUpContent({...selectedWarmUpContent, content})
      props.handleOptionalWarmUpContent(content);
    }

    if(ContentType == "cool-down" && !props.parentContentId){
      // setSelectedWarmUpContent({...selectedCoolDownContent, content})
      props.handleCoolDownContent(content);
    }

    if(ContentType == "cool-down" && props.parentContentId){
      props.handleOptionalCoolDownContent(content);
    }

    if(ContentType == "day-workout" && dayIndex != -1){
      props.handleDayWorkoutContent(content);
    }
  }

  const handleSearchingData = (searchingData) => {
    setSearchKey(searchingData);
  }

  const handleMemberScroll = throttle(async (event) => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo.content < pageCount.content && !isMemberSpinnerLoader) {
        if (pageNo.content < pageCount.content) {
        pageNo.content = pageNo.content + 1;
          setPageNo({
            ...pageNo
          })
          setMemberSpinnerLoader(true);
          await GetAllContents();
          setMemberSpinnerLoader(false)
        }
      }
    } catch (error) {
      setMemberSpinnerLoader(false)
    }
  }, 800);

  const handleSelectedContent = (content) => {
    console.log(content);
    setSelectedContent(content);
    setContentPreviewOpen(true);
  }

  const handleCloseContentPreview = () => {
    setSelectedContent("");
    setContentPreviewOpen(false);
  }

  const handleCloseContentList = () => {
    props.toggleContentList();
    setSelectedContent("");
    setContentPreviewOpen(false);
    setContents([])
  }

  useEffect(() => {

    if(props.contentsList){
      const allIds = props.contentsList.flatMap(day =>
        day.content.flatMap(ex => [
          ex._id,
          ...(ex.optionalContent?.map(o => o._id) || [])
        ])
      );
      setExistingContents(allIds);
    }

    if(props.warmUpContents){
      const allIds = props.warmUpContents.flatMap(ex => [
        ex._id,
        ...(ex.optionalExercises?.map(o => o._id) || [])
      ]);
      setExistingContents(allIds);
    }

    if(props.coolDownContents){
      const allIds = props.coolDownContents.flatMap(ex => [
        ex._id,
        ...(ex.optionalExercises?.map(o => o._id) || [])
      ]);
      setExistingContents(allIds);
    }

    setDayIndex(props.dayIndex);
   
    if(props.contentType){
      setContentType(props.contentType);
    }
  },[props])


  useEffect(async () => {
    if(props.contentType != null && props.selectedGym){
      try {
        // pageNo.content = 1;
        // setPageNo({
        //   ...pageNo
        // })
        await startLoader()
        await GetContentCount()
        await GetAllContents(true)
        await stopLoader()
      } catch (error) {
        await stopLoader()
      }
    }
  }, [props, contentVariation, sortByAccessRight, sortExerciseTypeIDs, sortExerciseLevelIDs, sortTargetMuscleIDs, ContentType, ContentRole, searchKey]);


  return(
    <div className="w-full h-full">
      <SearchFilter isSearchEnabled={true} isFilterEnabled={true} searchType={"Content"} searchLocation={"modal-search"} searchingData={handleSearchingData} count={total.content} filterSection="content-filter" isSticky={false} selectedGym={props.selectedGym} contentPrivacy={contentPrivacy} contentRole={contentRole} setParameterFilter={setParameterFilter} />
      {/* <div className="d-flex exercise-to-be-added-container m-t-12 m-b-12">
        <p className="flex-item font-weight-600 margin-auto" style={{color:"#8C130F"}}>Adding Exercise to : Exercise 1</p>
      </div> */}
      <div onScroll={handleMemberScroll} className="flex-item w-full p-r-8 m-t-20" style={{height:"64%", overflowY:"auto"}}>
        {
          contents.filter(item => !existingContents.includes(item._id)).map(data => {
            return(
              <div className="d-flex space-between w-full m-b-12 p-b-12" style={{borderBottom:"1px solid #ffffff"}}>
                <div onClick={()=>handleSelectedContent(data)} className="d-flex flex-item cursor-pointer" style={{width:"80%"}}>
                  <div className="content-preview-button d-flex">
                    <svg className="margin-auto flex-item" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.75 4.75C3.15 -0.583333 10.35 -0.583333 12.75 4.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M6.75 7.41675C6.48736 7.41675 6.22728 7.36502 5.98463 7.26451C5.74198 7.164 5.5215 7.01668 5.33579 6.83096C5.15007 6.64524 5.00275 6.42477 4.90224 6.18212C4.80173 5.93946 4.75 5.67939 4.75 5.41675C4.75 5.1541 4.80173 4.89403 4.90224 4.65138C5.00275 4.40873 5.15007 4.18825 5.33579 4.00253C5.5215 3.81682 5.74198 3.6695 5.98463 3.56899C6.22728 3.46848 6.48736 3.41675 6.75 3.41675C7.28043 3.41675 7.78914 3.62746 8.16421 4.00253C8.53929 4.37761 8.75 4.88632 8.75 5.41675C8.75 5.94718 8.53929 6.45589 8.16421 6.83096C7.78914 7.20603 7.28043 7.41675 6.75 7.41675Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <p className="fs-16 font-weight-700 m-l-8 m-t-3" style={{width:"80%"}}>{data.name}</p>
                </div>
                <div onClick={()=>addContent(data)} className="global-button-container button-red">
                  <p className="flex-item">Add</p>
                </div>
              </div>
            )
          })
        }
        {isMemberSpinnerLoader && <div className="loader-5 center"><span></span></div>}
      </div>
      
      <div onClick={()=>handleCloseContentList()} className="w-full d-flex" style={{position:"absolute", bottom:0, left:0, padding:"12px", background:"#ffffff", borderRadius:"0 0 20px 20px"}}>
        <div className="d-flex global-button-container flex-item margin-auto p-l-100 p-r-100" style={{borderRadius:"20px", height:"40px"}}>
          <p className="flex-item">Cancel</p>
        </div>
      </div>

      {
        isContentPreviewOpen && (
          <div onClick={()=>handleCloseContentPreview()} className="flex-item d-flex" style={{position:"absolute", bottom: 0, left: 0, width:"100%", height:"100%", zIndex:12, borderRadius:"16px", background:"rgba(0,0,0,0.25)", transition:"180ms"}}>
            <div style={{width:"100%", height:"auto", borderRadius:"0 0 20px 20px", alignSelf:"flex-end", background:"#ffffff", padding:"12px"}}>
              <iframe allowFullScreen className="exercise-video-container" style={{borderRadius:"12px", height:"310px"}} src={selectedContent.videoList[0].link} />
            </div>
          </div>
        )
      }
    </div>
  )
} 

export default ContentList;